var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "26px",
    viewBox: "0 0 22 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-2",
    transform: "translate(1.000000, 1.000000)",
    fill: "#47CCF0",
    fillRule: "nonzero",
    stroke: "#282828",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.44294217,0.344811089 C1.46855231,-0.460791912 6.39488462e-14,0.235194731 6.39488462e-14,1.5025992 L6.39488462e-14,22.4972289 C6.39488462e-14,23.8861427 1.71797843,24.5289334 2.6230368,23.478512 L7.88589811,17.3709507 C8.31141609,16.8770846 8.9297539,16.5933329 9.5800541,16.5933329 L17.9319459,16.5933329 C19.3333623,16.5933329 19.9632006,14.8302327 18.8814081,13.9357848 L2.44294217,0.344811089 Z",
    id: "Path",
    transform: "translate(9.714286, 12.000000) scale(-1, 1) translate(-9.714286, -12.000000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/cursor.16349a92cfcac94a53bbc49133ef63e5.svg";
export { ForwardRef as ReactComponent };